/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

/**
 * Complément du numéro d'acte, avec les libellés de l'ETCV (AD-12852).
 *
 * La base stocke l'indice de la liste de l'ETCV (`xx_a_num_cpl`), dont la
 * première ligne est VIDE : vide, 0 et 1 valent « aucun complément » (l'ETCV
 * filtre ses actes ordinaires sur `num_cpl < 2 OR IS NULL`), puis 2 = Bis …
 * 10 = Decies.
 */
const PREMIER_COMPLEMENT = 2;

const OPTIONS_COMPLEMENT_ACTE = _.map(
  [
    'Bis',
    'Ter',
    'Quater',
    'Quinquies',
    'Sexies',
    'Septies',
    'Octies',
    'Novies',
    'Decies',
  ],
  (text, index) => ({
    key: index + PREMIER_COMPLEMENT,
    value: index + PREMIER_COMPLEMENT,
    text,
  }),
);

/** Vide, 0 ou 1 : pas de complément (cf. `OPTIONS_COMPLEMENT_ACTE`). */
export const estSansComplement = (
  complement: number | string | null | undefined,
): boolean =>
  _.isNil(complement) ||
  complement === '' ||
  Number(complement) < PREMIER_COMPLEMENT;

/**
 * Libellé d'un complément : `'Bis'` pour 2. Chaîne vide sans complément ; une
 * valeur hors liste, héritée de l'ancienne saisie libre, reste affichée telle
 * quelle plutôt que masquée.
 */
export const libelleComplementActe = (
  complement: number | string | null | undefined,
): string => {
  if (estSansComplement(complement)) {
    return '';
  }

  return (
    _.find(OPTIONS_COMPLEMENT_ACTE, { value: Number(complement) })?.text ??
    String(complement)
  );
};

/**
 * Options du dropdown, complétées d'une entrée pour une valeur hors liste
 * déjà enregistrée : sans elle, le champ s'afficherait vide et la valeur
 * serait perdue au prochain enregistrement.
 */
export const optionsComplementActe = (
  complement: number | string | null | undefined,
) => {
  const valeur = Number(complement);

  if (
    estSansComplement(complement) ||
    _.isNaN(valeur) ||
    _.some(OPTIONS_COMPLEMENT_ACTE, { value: valeur })
  ) {
    return OPTIONS_COMPLEMENT_ACTE;
  }

  return [
    ...OPTIONS_COMPLEMENT_ACTE,
    { key: valeur, value: valeur, text: String(complement) },
  ];
};

export default OPTIONS_COMPLEMENT_ACTE;
